import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function MissionVisionSkeleton() {
    return <Skeleton height={140} />;
}
